import { useEffect, useRef, useState } from 'react';
import { auth } from '../../config/firebaseConfig';
import { shouldShowWelcome, markWelcomeSeen } from '../../utils/firstLoginWelcome';

/**
 * Sisteme ilk kez giriş yapan çalışanlara karşılama mesajı gösterilsin mi?
 * Kontrol yalnızca bir kez çalışır; detaylar için utils/firstLoginWelcome.js
 * Returns [showWelcome, setShowWelcome].
 */
const useFirstLoginWelcome = (employeeId) => {
  const [showWelcome, setShowWelcome] = useState(false);
  // Karşılama kontrolünün her render'da tekrarlanmasını önler
  const welcomeCheckedRef = useRef(false);

  useEffect(() => {
    if (!employeeId || welcomeCheckedRef.current) return;
    welcomeCheckedRef.current = true;

    // NOT: Burada "unmount" temizliği KULLANILMAZ. React.StrictMode geliştirme
    // ortamında effect'leri iki kez çalıştırır; temizlik bayrağı ilk çalıştırmada
    // sonucu iptal eder, ref ise ikinci çalıştırmayı engellerdi ve mesaj hiç
    // açılmazdı. React 18'de setState'in geç çalışması zararsızdır.
    shouldShowWelcome(employeeId).then((isNewcomer) => {
      if (!isNewcomer) return;
      // Gösterildiği anda işaretle: sayfa yenilense bile tekrar açılmasın.
      markWelcomeSeen(auth.currentUser?.uid);
      setShowWelcome(true);
    });
  }, [employeeId]);

  return [showWelcome, setShowWelcome];
};

export default useFirstLoginWelcome;
